import { render, staticRenderFns } from "./CaixaCombo.vue?vue&type=template&id=715daabd"
import script from "./CaixaCombo.vue?vue&type=script&lang=js"
export * from "./CaixaCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports